import React from "react"

import ReviewHeroSectionDesktop from "./ReviewHeroSectionDesktop"
import ReviewHeroSectionMobile from "./ReviewHeroSectionMobile"

const ReviewHeroSection = ({
  section,
  practice,
  theme,
  highlightedField,
  viewMode = "",
  deviceType = "desktop",
  pageSlug = null,
  defaultPageType = null
}) => {
  const commonProps = { section, practice, theme, highlightedField, pageSlug, defaultPageType }

  if (viewMode === "mobile") {
    return <ReviewHeroSectionMobile {...commonProps} />
  }

  if (viewMode === "desktop") {
    return <ReviewHeroSectionDesktop {...commonProps} />
  }

  if (deviceType === "mobile") {
    return <ReviewHeroSectionMobile {...commonProps} />
  }

  return <ReviewHeroSectionDesktop {...commonProps} />
}

export default ReviewHeroSection
